import React, { Component, Fragment } from 'react';
import { NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import authService from './AuthorizeService';
import { ApplicationPaths } from './ApiAuthorizationConstants';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import { isEmpty } from "lodash";
import Button from "@material-ui/core/Button";
import { infoColor } from 'assets/jss/material-kit-pro-react.js';

export class LoginMenu extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isAuthenticated: false,
            userName: null
        };
    }

    componentDidMount() {
        this._subscription = authService.subscribe(() => this.populateState());
        this.populateState();
    }

    componentWillUnmount() {
        authService.unsubscribe(this._subscription);

        this.setState = (state, callback) => {
            return;
        };
    }

    async populateState() {
        const [isAuthenticated, user] = await Promise.all([authService.isAuthenticated(), authService.getUser()])
        this.setState({
            isAuthenticated,
            userName: user && user.name
        });

        //console.log(user);
    }

    render() {
        const { isAuthenticated, userName } = this.state;
        if (!isAuthenticated) {
            const registerPath = `/Register`;
            //const loginPath = `${ApplicationPaths.Login}`;
            const loginPath = '/Login';
            return this.anonymousView(registerPath, loginPath);
        } else {
            const profilePath = `/EditAccount`;
            const logoutPath = { pathname: `${ApplicationPaths.LogOut}`, state: { local: true } };
            return this.authenticatedView(userName, profilePath, logoutPath);
        }
    }

    authenticatedView(userName, profilePath, logoutPath) {
        const { isLandingPage } = this.props;
        return (<Fragment>
            <div>

                <NavLink tag={Link} style={{ color: isLandingPage ? infoColor[1] : "white" }} to={profilePath} >  {userName}  </NavLink>

            </div>

            <div>
                <NavLink tag={Link} style={{ color: isLandingPage ? infoColor[1] : "white", marginLeft: 30 }} to={logoutPath}>  
                    Logout
       
                    </NavLink>
            </div>
        </Fragment>);

    }

    anonymousView(registerPath, loginPath) {
        return (<Fragment>
            <div>
                <NavLink tag={Link} style={{ color: 'white' }} to={registerPath}>  <Button
                    style={{
                        borderRadius: 10,
                        backgroundColor: infoColor[0],
                        padding: "4px 6px",
                        color: "#FFFFFF"
                    }}
                    target="_blank"
                >
                   Register
                </Button>
                </NavLink>
            </div>

            {isEmpty(this.state.userName) ?
                <div>
                    <NavLink tag={Link} style={{ color: 'white', marginLeft: 15 }} to={loginPath}>  <Button
                        style={{
                            borderRadius: 10,
                            backgroundColor: infoColor[0],
                            padding: "4px 6px",
                            color: "#FFFFFF"
                        }}
                        target="_blank"
                    >
                        Login
                    </Button></NavLink>
                </div>
                : null}

        </Fragment>);
    }
}
